export default __webpack_public_path__ + "static/media/logo.92cd1287.png";